var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5938 6.85156V6.86021",
    stroke: "#596475",
    strokeWidth: 1.47827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5939 13.315L14.3664 8.69949C14.0542 8.1369 13.8944 7.50257 13.9026 6.85925C13.9109 6.21593 14.0869 5.5859 14.4134 5.0315C14.7398 4.47709 15.2053 4.0175 15.7639 3.6982C16.3224 3.3789 16.9547 3.21094 17.598 3.21094C18.2414 3.21094 18.8736 3.3789 19.4322 3.6982C19.9907 4.0175 20.4562 4.47709 20.7827 5.0315C21.1091 5.5859 21.2852 6.21593 21.2934 6.85925C21.3017 7.50257 21.1418 8.1369 20.8297 8.69949L17.5939 13.315Z",
    stroke: "#596475",
    strokeWidth: 1.47827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6717 5.69377L9.28376 5.00391L3.74023 7.77156V19.7866L9.28376 17.0108L14.8273 19.7866L20.3708 17.0108V15.1629",
    stroke: "#596475",
    strokeWidth: 1.47827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2832 5.00391V17.0108",
    stroke: "#596475",
    strokeWidth: 1.47827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8262 15.1641V19.7878",
    stroke: "#596475",
    strokeWidth: 1.47827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.22842a70f486380d3a107078ee76e25e.svg";
export { ForwardRef as ReactComponent };